import { useGetSmsCampaigns } from "../../../../../hooks/api/queries/useMarketing";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";

export const useAllSmsAutomatedCampaigns = () => {
  const { search, queries, filterBySearch, gotoPage } = useUrlSearch();
  const { data, isLoading } = useGetSmsCampaigns({
    queries,
    queryParams: { campaign_type: "PREDEFINED" },
  });

  return {
    campaigns: data?.data || [],
    metaDetails: data?.meta || {},
    isLoadingSmsCampaigns: isLoading,
    search,
    gotoPage,
    filterBySearch,
  };
};
